import type { ModalComponentProps } from "@/lib/modal";
import { ConfirmationModal } from "@/components/modals/confirmation-modal";
import { useBulkDeleteDocuments } from "@/lib/api/knowledge-base";

export interface BulkDeleteDocumentsModalProps {
  applicationGuildId: string;
  documentIds: number[];
  onDeleted: () => void;
}

export function BulkDeleteDocumentsModal({
  applicationGuildId,
  documentIds,
  onDeleted,
  onClose,
}: BulkDeleteDocumentsModalProps & ModalComponentProps) {
  const bulkDeleteMutation = useBulkDeleteDocuments(applicationGuildId);

  const handleDelete = async () => {
    await bulkDeleteMutation.mutateAsync(documentIds);
    onDeleted();
    onClose();
  };

  return (
    <ConfirmationModal
      title="Delete Documents"
      description={`Are you sure you want to delete ${documentIds.length} document${documentIds.length !== 1 ? "s" : ""}? This action cannot be undone.`}
      confirmLabel="Delete All"
      pendingLabel="Deleting..."
      onConfirm={handleDelete}
      isPending={bulkDeleteMutation.isPending}
      onClose={onClose}
    />
  );
}

BulkDeleteDocumentsModal.displayName = "BulkDeleteDocumentsModal";
